module.exports = __webpack_public_path__ + "media/images/brain-icon-36056d10f2ed42da576dae856590ca50.png";